import { useState } from 'react';

const useSuccessModal = () => {
  const [isModalOpen, setOpen] = useState(false);

  function showModal() {
    setOpen(true);
    setTimeout(() => setOpen(false), 3000);
  }

  function closeModal() {
    setOpen(false);
  }

  return {
    isModalOpen,
    showModal,
    closeModal,
  };
};

export default useSuccessModal;
